"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToCart = void 0;
var _react = _interopRequireDefault(require("react"));
var _AddToCartActionView = require("./AddToCartActionView");
var _AddFavorite = require("./AddFavorite");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AddToCart = exports.AddToCart = function AddToCart(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "add-to-cart-generic d-flex justify-content-center"
  }, !props.preventPurchase && props.permitPurchase ? /*#__PURE__*/_react["default"].createElement(_AddToCartActionView.AddToCartActionView, {
    list: props.dataValues.list,
    setLength: props.dataValues.setLength,
    itemSelected: props.dataValues.itemSelected,
    AddItemSelected: props.dataValues.AddItemSelected,
    favSelected: props.dataValues.favSelected,
    setFavorite: props.dataValues.setFavorite,
    removeFavorite: props.dataValues.removeFavorite,
    manageList: props.dataValues.manageList,
    addNote: props.addNote,
    added: props.added,
    charRemain: props.dataValues.charRemain,
    inputVal: props.dataValues.inputVal,
    buttonClass: props.buttonClass,
    buttonContent: props.buttonContent,
    saveNote: props.dataValues.saveNote,
    addedNoteIcon: props.dataValues.addedNoteIcon,
    tooltipText: props.dataValues.tooltipText,
    addedToCart: props.addedToCart,
    supercedeItems: props.supercedeItems,
    itemIdentifier: props.itemIdentifier,
    changeZIndex: props.changeZIndex,
    quantityMessage: props.quantityMessage,
    errorMessage: props.errorMessage,
    error: props.error,
    doPreventAddToCart: props.doPreventAddToCart,
    isSkuGroupSearch: props.isSkuGroupSearch,
    slideInfo: props.slideInfo,
    qtyOnBlur: props.qtyOnBlur,
    forceInput: props.forceInput,
    isAddToCartActive: props.isAddToCartActive,
    inputIdentifier: props.inputIdentifier,
    inputLabel: props.inputLabel
  }) : props.preventPurchase ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "unavailable-container d-flex justify-content-center align-items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-weight-bold account-unavailable"
  }, "Not available for purchase at this time."), props.productCard && props.dataValues.setFavorite && /*#__PURE__*/_react["default"].createElement(_AddFavorite.AddToCartFavorite, {
    favSelected: props.dataValues.favSelected,
    setFavorite: function setFavorite() {
      return props.dataValues.setFavorite();
    }
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "unavailable-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-weight-bold account-unavailable"
  }, props.restrictedLink), props.restrictedMessage && /*#__PURE__*/_react["default"].createElement("div", {
    className: "account-text"
  }, props.restrictedMessage)));
};
//# sourceMappingURL=AddToCart.js.map